var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("interessado-sicarf", {
        attrs: {
          interessado: _vm.cadastro.interessado,
          cadastrante: _vm.cadastro.cadastrante,
          hasProcurador: true,
          hasEspolio: true,
          observer: _vm.observer
        },
        on: { changedTipoPessoa: _vm.changedTipoPessoa }
      }),
      _c("app-documentos", {
        attrs: {
          maxSize: 25,
          "valid-extensions": ["doc", "docx", "jpeg", "jpg", "pdf", "png"],
          documentos: _vm.cadastro.interessado.documentos,
          tiposDocumentos: _vm.documentos,
          tiposDocumentosObrigatorios: _vm.documentosObrigatorios,
          observer: _vm.observer,
          aba: "Interessado"
        },
        on: {
          addedDoc: _vm.addedDocProcurardor,
          removedDoc: _vm.removedDocProcurardor
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48e4c569", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e4c569","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/solicitarInformacao/components/Interessado.vue
// module id = null
// module chunks = 